import { useEffect, useLayoutEffect } from 'react'

/**
 * `useLayoutEffect` in the browser, `useEffect` on the server.
 *
 * A layout effect and its cleanup run synchronously while React commits, before
 * any promise callback can run, so a ref it updates is current for async work
 * that settles right after a render. React 18 warns when `useLayoutEffect` is
 * rendered on the server, where neither effect runs, so the server gets
 * `useEffect` instead.
 */
const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect

export default useIsomorphicLayoutEffect
